import React from 'react'
import ResetButton from "../components/gameSetupAndLobby/DeleteMyDataButtons";
import PageHeader from "../components/gamePlayComponents/PageHeader";
import CardContainer from "../components/courseContentDisplays/CardContainer";
import Typography from "@mui/material/Typography";

const DeleteMyData = () => {

  return(<>
    <PageHeader title={''} goBack/>
    <CardContainer
      alternateHeader
      cardContent1={<>
        <Typography variant={'h6'} style={{textAlign: 'center'}}>Delete my data</Typography>
        <ResetButton/>
        </>}
    />
    </>)
};

export default DeleteMyData;